import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from './auth-service';
import {UserApiService} from '../../services/user-api-service';
import {catchError, map, Observable, of, take} from 'rxjs';

export const roleGuard: CanActivateFn = (route, state) : Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const userApiService = inject(UserApiService);
  const router = inject(Router);

  const userId = authService.loginUser()?.id;
  if (userId === undefined) {
    return of(router.parseUrl('/unauthorized'));
  }

  return userApiService.isAdmin(userId).pipe(
    take(1),
    map(isAdmin => {
      if (isAdmin) {
        return true;
      }
      else {
        return router.parseUrl('/unauthorized');
      }
    })
  );
};
